import React from 'react';

function Loading() {
    return (
        <div className="flex w-full flex-col items-center justify-center h-full">
            <div className="rounded-full w-[5em] h-[5em] my-[1em] mx-auto relative indent-[-9999em] border-[0.7em] border-solid border-[#e7e7e7] border-t-[#4eb32d] [animation:load8_1s_infinite_linear]"></div>
        </div>
    );
}

export default Loading;
